import { ToggleFilterHandler } from './filters/ToggleFilterHandler'
import { FilterHandler } from './filters/FilterHandler'
import { RangeFilterHandler } from './filters/RangeFilterHandler'
import { DistanceFilterHandler } from './filters/DistanceFilterHandler'

export const findFilterByType = filter => {
  switch (filter?.type) {
    case 'toggle':
      return new ToggleFilterHandler(filter)
    case 'range':
      return new RangeFilterHandler(filter)
    case 'zipcode.select':
      return new DistanceFilterHandler(filter)
    default:
      return new FilterHandler(filter)
  }
}

export const findFilterById = (filterId, filters) => {
  const filter = filters.find(fltr => fltr.id === filterId)

  return findFilterByType(filter)
}
